import { Measurement } from "./_types";

export const LIB_MEASURES_FRUT_VINE: Measurement[] = [
    {
        id: "vine_total_bud",
        unit: "#",
        label: "Total Buds",
        tag: "TBUD",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_total_bud",
        format: "##0",
        min: 0,
        max: 9999,
        suggestMin: 1,
        suggestMax: 9999,
        subjectId: "vine",
    },
    {
        id: "vine_bud_per_square",
        unit: "#",
        label: "Buds per Square Meter",
        tag: "BPS",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_bud_per_square",
        format: "##0",
        min: 0,
        max: 9999,
        suggestMin: 1,
        suggestMax: 9999,
        subjectId: "vine",
    },
    {
        id: "vine_bud_flower",
        unit: "#",
        label: "Buds with flowers",
        tag: "BUF",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_bud_flower",
        format: "##0",
        min: 0,
        max: 9999,
        suggestMin: 1,
        suggestMax: 9999,
        subjectId: "vine",
    },
    {
        id: "vine_bud_no_flower",
        unit: "#",
        label: "Buds without flowers",
        tag: "BUWF",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_bud_no_flower",
        format: "##0",
        min: 0,
        max: 9999,
        suggestMin: 1,
        suggestMax: 9999,
        subjectId: "vine",
    },
    {
        id: "vine_total_flower",
        unit: "#",
        label: "Total flowers",
        tag: "TFL",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_total_flower",
        format: "##0",
        min: 0,
        max: 9999,
        suggestMin: 1,
        suggestMax: 9999,
        subjectId: "vine",
    },
    {
        id: "vine_side_flower",
        unit: "#",
        label: "Side flowers",
        tag: "TSF",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_bud_flower",
        format: "##0",
        min: 0,
        max: 9999,
        suggestMin: 1,
        suggestMax: 9999,
        subjectId: "vine",
    },
    {
        id: "vine_misshaped_flower",
        unit: "#",
        label: "Misshaped flowers",
        tag: "TSF",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_bud_flower",
        format: "##0",
        min: 0,
        max: 9999,
        suggestMin: 1,
        suggestMax: 9999,
        subjectId: "vine",
    },
    {
        id: "vine_total_king_flower",
        unit: "#",
        label: "King flowers",
        tag: "TKFL",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_total_king_flower",
        format: "##0",
        min: 0,
        max: 9999,
        suggestMin: 1,
        suggestMax: 9999,
        subjectId: "vine",
    },
    {
        id: "vine_triplets",
        unit: "#",
        label: "Triplets",
        tag: "TRIP",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_triplets",
        format: "##0",
        min: 0,
        max: 9999,
        suggestMin: 1,
        suggestMax: 9999,
        subjectId: "vine",
    },
    {
        id: "vine_flower_per_square",
        unit: "#",
        label: "Flowers per Square Meter",
        tag: "FPS",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_flower_per_square",
        format: "##0",
        min: 0,
        max: 9999,
        suggestMin: 1,
        suggestMax: 9999,
        subjectId: "vine",
    },
    {
        id: "vine_cane_len",
        unit: "cm",
        label: "Cane Length",
        tag: "CLN",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_cane_len",
        format: "####cm",
        min: 0,
        max: 999,
        suggestMin: 1,
        suggestMax: 999,
        subjectId: "vine",
    },
    {
        id: "vine_fruit_per_square",
        unit: "#",
        label: "Fruit per Square Meter",
        tag: "FRPS",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_vine_fruit_per_square",
        format: "##0",
        min: 0,
        max: 9999,
        suggestMin: 1,
        suggestMax: 9999,
        subjectId: "vine",
    },
    {
        id: "vine_est_yield",
        unit: "kg",
        label: "Estimated Yield",
        tag: "EYI",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_tree_est_yield_10",
        format: "####kg",
        min: 0,
        max: 9999,
        suggestMin: 0,
        suggestMax: 9999,
        subjectId: "vine",
    },
];